import { Routine } from 'redux-saga-routines';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { Integration } from '../../../../common/enums/Integration';
import { INameData } from '../../../../common/models/common/INameData';
import { getSurveyNames } from '../../../../services/surveyService';
import {
  deleteLeverIntegration,
  getIntegrationsData,
  getLeverStages,
  updateLeverStage,
  updateLeverSurvey
} from '../../../../services/workspaceService';
import {
  disconnectFromLeverRoutine,
  getIntegrationsDataRoutine,
  getLeverStagesRoutine,
  getSurveyNamesRoutine,
  setLeverStageRoutine,
  setLeverSurveyRoutine
} from '../../routines';

function* getIntegrationsReq() {
  try {
    const integrations = yield call(getIntegrationsData);

    if (integrations[Integration.Lever]) {
      const [stages, surveys]: [INameData[], INameData[]] = yield all([
        call(getLeverStages),
        call(getSurveyNames)
      ]);
      yield put(getLeverStagesRoutine.success(stages));
      yield put(getSurveyNamesRoutine.success(surveys));
    }

    yield put(getIntegrationsDataRoutine.success(integrations));
  } catch (error) {
    yield put(getIntegrationsDataRoutine.failure(error.message));
  }
}

function* watchGetIntegrations() {
  yield takeEvery(getIntegrationsDataRoutine.TRIGGER, getIntegrationsReq);
}

function* disconnectFromLeverReq() {
  try {
    yield call(deleteLeverIntegration);
    yield put(disconnectFromLeverRoutine.success());
  } catch (error) {
    yield put(disconnectFromLeverRoutine.failure(error.message));
  }
}

function* watchDisconnectFromLever() {
  yield takeEvery(disconnectFromLeverRoutine.TRIGGER, disconnectFromLeverReq);
}

function* setLeverStageReq({ payload }: Routine<any>) {
  try {
    yield call(updateLeverStage, payload);
    yield put(setLeverStageRoutine.success(payload));
  } catch (error) {
    yield put(setLeverStageRoutine.failure(error.message));
  }
}

function* watchSetLeverStage() {
  yield takeEvery(setLeverStageRoutine.TRIGGER, setLeverStageReq);
}

function* setLeverSurveyReq({ payload }: Routine<any>) {
  try {
    yield call(updateLeverSurvey, payload);
    yield put(setLeverSurveyRoutine.success(payload));
  } catch (error) {
    yield put(setLeverSurveyRoutine.failure(error.message));
  }
}

function* watchSetLeverSurvey() {
  yield takeEvery(setLeverSurveyRoutine.TRIGGER, setLeverSurveyReq);
}

export default function* integrationsSaga() {
  yield all([
    watchGetIntegrations(),
    watchDisconnectFromLever(),
    watchSetLeverStage(),
    watchSetLeverSurvey()
  ]);
}
